<template>
  <div id="searchWrap">
    <ly-search v-model="keyword" placeholder="输入关键词搜索地址" @search="searchResult" :enter-button="btn ? '搜索' : false" />
    <p v-show="searching" id="searching">内容搜索中</p>
    <div class="searchUl123" v-show="openSelect">
      <ul>
        <li style="margin-bottom: 10px;" v-for="(item, index) in carArr" :key="index" @click="clickSearch(item)" class="clearfloat">
          <h4 style="font-weight: bold;">{{ item.name }}</h4>
          <p>{{ item.address1 }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["btn"],
  data() {
    return {
      //搜索
      openSelect: false,
      keyword: "",
      searching: false,
      carArr: [],
      userGroupArr: [],
      deviceArr: [],
      simArr: [],
    };
  },
  methods: {
    searchResult() {
      this.searching = true;
      if (this.keyword.length < 2) {
        this.carArr = [];
        this.searching = false;
        this.openSelect = false;
        return;
      }
      let params = {
        keyword: this.keyword,
        returnCoord: 2,
      };
      this.axios({
        method: "post",
        url: this.axios.lbs + "/lbs/search",
        data: params,
      }).then((res) => {
        this.searching = false;
        var data = res.data.data;
        for (let i = 0; i < data.length; i++) {
          data[i].address1 =
            data[i].adname +
            (data[i].address == '[]' ? '' : data[i].address)

        }
        this.carArr = data;
        this.openSelect = true;
      });
    },
    clickSearch(row) {
      this.$emit("adds", row);
      this.keyword = row.name;
      this.openSelect = false;
      this.carArr = [];
    },
  },
  watch: {
    keyword(v) {
      if (v.length == 0) {
        this.$emit("clearAdd");
      }
    },
  },
};
</script>
<style lang="">
#searchWrap {
  position: relative;
  width: 400px;
}
#searching {
  position: absolute;
  left: 0;
  top: 30px;
  z-index: 20;
  background: #fff;
  width: 100%;
  border: solid 1px #ccc;
  padding: 10px;
  line-height: 2;
}
.searchUl123 {
  position: absolute;
  left: 0;
  top: 30px;
  z-index: 20;
  background: #fff;
  width: 100%;
  max-height: 300px;
  border: solid 1px #ccc;
  overflow: auto;
  padding: 10px;
  line-height: 2;
}
.searchUl123 li:hover {
  cursor: pointer;
  color: red;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/searchAdd.vue